import createApp from './app.js'

import authService from './service.auth.js'
import storageService from './service.storage.js'
import analyticsService from './service.analytics.js'

const appConfig = {"apiKey":"AIzaSyBQ1kR6bWdaILenGSOko3mBfj0eVJgzar4","authDomain":"emoex-9aa45.firebaseapp.com","projectId":"emoex-9aa45","storageBucket":"emoex-9aa45.appspot.com","messagingSenderId":"1038178882666","appId":"1:1038178882666:web:6551c44217424034342613","measurementId":"G-0N23QHNEJC"}

export default async (ctx, inject) => {
  const { firebase, session } = await createApp(appConfig, ctx)

  let servicePromises = []

  if (process.server) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
    storageService(session, firebase, ctx, inject),

    ]
  }

  if (process.client) {
    servicePromises = [
      authService(session, firebase, ctx, inject),
      storageService(session, firebase, ctx, inject),
      analyticsService(session, firebase, ctx, inject),

    ]
  }

  const [
    auth,
    storage,
    analytics
  ] = await Promise.all(servicePromises)

  const fire = {
    auth: auth,
    storage: storage,
    analytics: analytics
  }

    inject('fireModule', firebase)
    ctx.$fireModule = firebase

  inject('fire', fire)
  ctx.$fire = fire
}

function forceInject (ctx, inject, key, value) {
  inject(key, value)
  const injectKey = '$' + key
  ctx[injectKey] = value
  if (typeof window !== "undefined" && window.$nuxt) {
  // If clause makes sure it's only run when ready() is called in a component, not in a plugin.
    window.$nuxt.$options[injectKey] = value
  }
}